import { Components } from '@formio/js';
import { ApplicationRef, ComponentRef, createComponent } from '@angular/core';
import { PdfUploadComponent } from './pdf-upload.component';
import { environmentInjector } from '../../../../../shared/formio-environment';

const Field = (Components as any).components.field;

export class PdfUploadFormioComponent extends Field {
    constructor(...args: any[]) {
        super(...args);
    }

    static schema(...extend) {
        return Field.schema({
            type: 'pdfUpload',
            label: 'Arquivo PDF',
            key: 'pdfUpload',
            ...extend,
        });
    }

    static get builderInfo() {
        return {
            title: 'Arquivo PDF',
            selector: 'pdf-upload',
            icon: 'fa fa-file',
            group: 'basic',
            schema: PdfUploadFormioComponent.schema(),
        };
    }

    angularRef?: ComponentRef<PdfUploadComponent>;

    render(children) {
        return super.render(`<div class="formio-angular-host"></div>`);
    }

    attach(element) {
        const result = super.attach(element);

        const host = element.querySelector('.formio-angular-host');
        if (!host) return result;

        if (!environmentInjector) {
            console.warn('No EnvironmentInjector found');
            return result;
        }

        this.angularRef = createComponent(PdfUploadComponent, {
            environmentInjector: environmentInjector,
            hostElement: host
        });

        Object.assign(this.angularRef.instance, {
            _disabled: this.disabled,
            _value: this.dataValue
        });

        this.angularRef.instance._valueChange.subscribe(val => this.setValue(val, {}));

        this.angularRef.instance.ngOnChanges();

        const appRef = environmentInjector.get(ApplicationRef);
        appRef.attachView(this.angularRef.hostView);

        this.on('destroy', () => {
            appRef.detachView(this.angularRef.hostView);
            this.angularRef.destroy();
        });

        return result;
    }

    setValue(value, flags) {
        super.setValue(value, flags);
        if (this.angularRef?.instance && this.angularRef.instance._value !== value) {
            this.angularRef.instance._value = value;
        }
    }

    detach() {
        if (this.angularRef) {
            this.angularRef.destroy();
            this.angularRef = undefined;

            if (this.appRef) {
                this.appRef.detachView(this.angularRef.hostView);
                this.appRef = undefined;
            }
        }
        super.detach();
    }
}

Components.addComponent('pdfUpload', PdfUploadFormioComponent);
